import { render, staticRenderFns } from "./MapaEleciones.vue?vue&type=template&id=75a77389&"
import script from "./MapaEleciones.vue?vue&type=script&lang=js&"
export * from "./MapaEleciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports